/**
 * The italic-last-word motif (redesign handoff §2): the final word of a
 * display heading — trailing punctuation included — wraps in `<em>`. Done in
 * markup at render, never inside i18n strings, so translators see plain text
 * and the motif survives retranslation.
 */
import type { JSX } from 'react'

export function italicLast(text: string): JSX.Element {
  const trimmed = text.trimEnd()
  const cut = trimmed.lastIndexOf(' ')
  if (cut < 0) return <em>{trimmed}</em>

  return (
    <>
      {trimmed.slice(0, cut + 1)}
      <em>{trimmed.slice(cut + 1)}</em>
    </>
  )
}
